/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Chemistry16Inputs */

const en__field__enum_additionalstudyinterests_study_chemistry16 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Chemistry16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemistry`)
};

const de__field__enum_additionalstudyinterests_study_chemistry16 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Chemistry16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemie`)
};

/**
* | output |
* | --- |
* | "Chemistry" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Chemistry16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_chemistry16 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Chemistry16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Chemistry16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_chemistry16(inputs)
	return de__field__enum_additionalstudyinterests_study_chemistry16(inputs)
});
export { _field__enum_additionalstudyinterests_study_chemistry16 as "_field__enum_additionalStudyInterests_STUDY_CHEMISTRY" }